module.exports = __webpack_public_path__ + "static/media/new-york-38.c30e24bd.jpg";